import { Box, Button, Typography, withStyles } from "@material-ui/core";
import React from "react";
import { SortEnd, arrayMove } from "react-sortable-hoc";
import Component from "src/shared/components/Component";
import Modal from "src/shared/components/Modal";
import SortableList from "src/shared/components/SortableList";
import withAxios from "src/shared/components/withAxios";
import { ISeasonResponse, ISeasonsOrderRequest } from "src/api/types";
import { getAdminApi } from "../../seasonsPage/utils/getAdminApi/getAdminApi";
import SeasonListItem from "../season-list-item/SeasonListItem";
import {
  CLOSE_MODAL_BUTTON_LABEL,
  DELETE_SEASON_BUTTON_LABEL,
  DELETE_SEASON_CONFIRMATION_HEADER,
  GET_DELETE_SEASON_CONFIRMATION,
} from "./constants";
import { styles } from "./styles";
import { IProps, ISeasonsPageState } from "./types";

export default withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISeasonsPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
      });

      public render() {
        const { classes, loadSeasons, seasons, setSeason } = this.props;
        const { deleteSeason, modalVisible } = this.state;

        const handleCloseModal = () => {
          this.setState({ modalVisible: false });
        };
        const handleOpenModal = (deleteSeason: ISeasonResponse) => {
          this.setState({ modalVisible: true, deleteSeason });
        };

        return (
          <>
            <SortableList
              useDragHandle={true}
              renderItem={(season: ISeasonResponse) => (
                <SeasonListItem
                  season={season}
                  openDeleteModal={(deleteSeason: ISeasonResponse) =>
                    handleOpenModal(deleteSeason)
                  }
                  loadSeasons={loadSeasons}
                  setSeason={setSeason}
                />
              )}
              items={seasons}
              onOrderChange={this.handleOrderChange}
            />
            <Modal open={modalVisible} closeModal={handleCloseModal}>
              <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="space-between"
              >
                <Box display="flex" flexDirection="column" gridGap="1.5rem">
                  <Typography variant="h4">
                    {DELETE_SEASON_CONFIRMATION_HEADER}
                  </Typography>
                  <Typography variant="body1">
                    {GET_DELETE_SEASON_CONFIRMATION(deleteSeason?.name)}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Button onClick={handleCloseModal} variant="contained">
                    {CLOSE_MODAL_BUTTON_LABEL}
                  </Button>
                  <Button
                    className={classes.deleteSeasonButton}
                    onClick={this.handleDeleteSeason}
                    variant="contained"
                    color="secondary"
                  >
                    {DELETE_SEASON_BUTTON_LABEL}
                  </Button>
                </Box>
              </Box>
            </Modal>
          </>
        );
      }

      private handleOrderChange = (sort: SortEnd) => {
        this.runCancellableStatefulAsync(
          this,
          {
            submittingNewOrder: true,
          },
          {
            submittingNewOrder: undefined,
          },
          async () => {
            const { seasons, seasonsChange, defaultSeasons, schoolId } =
              this.props;
            // re-order the season
            const seasonsInNewPosition = arrayMove(
              seasons,
              sort.oldIndex,
              sort.newIndex
            ).map((q, i) => {
              return Object.assign(q, { order: i });
            });
            seasonsChange(seasonsInNewPosition);
            await this.buildPut<ISeasonsOrderRequest, void>(
              this,
              `${getAdminApi(defaultSeasons)}seasonsOrder`
            )({
              schoolId,
              seasons: seasonsInNewPosition.map((seasonPos) => ({
                id: seasonPos.id,
                order: seasonPos.order,
              })),
            });
            this.props.loadSeasons();
          },
          () => {
            window.alert("Failed to update season order");
            this.setState({ submittingNewOrder: undefined });
          }
        );
      };

      private handleDeleteSeason = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {
            modalVisible: false,
          },
          async () => {
            const { defaultSeasons, schoolId } = this.props;
            const { deleteSeason } = this.state;
            if (deleteSeason !== undefined) {
              await this.buildDeleteWithParams<{}, { schoolId: number }>(
                this,
                `${getAdminApi(defaultSeasons)}season/${deleteSeason.id}`
              )({
                schoolId,
              });
              this.props.loadSeasons();
            }
          },
          () => {
            window.alert("Failed to delete season");
          }
        );
    }
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/season-list/SeasonsList.tsx